import { createSlice } from "@reduxjs/toolkit";
import { Movie } from "../types";

interface MoviesState {
  data: Movie[]
}

const initialState: MoviesState = {
  data: [
    {
      id: 1,
      img: "https://avatars.mds.yandex.net/get-afishanew/23114/1b65ed28-dcdb-40da-b4fd-ef7d35e12cb0/s190x280",
      title: "Паранормальное явление",
      genre: "Драма",
      actors: ["Арнольд Шварцнегер", "Джейсон Стетхем", "Дженифер Лопез"],
      country: "США",
      description: "Четверо блогеров-инфлюэнсеров отправляются в заброшенный дом, где когда-то жили оккультисты. Желая пощекотать нервишки своим зрителям, они обещают провести там ритуал. Но обычный развлекательный стрим превращается в настоящее противостояние с потусторонними силами.",
      duration: 83,
      premier: "7 сентября 2023",
      year: 2022,
      times: ["10:00", "12:30", "14:30", "16:30", "20:30", "22:30"]
    },
    {
      id: 2,
      img: "https://avatars.mds.yandex.net/get-afishanew/21422/16060eee-73a2-4e99-bf8a-10ae60a366af/s190x280",
      title: "Баба Яга спасает мир",
      genre: "Семейное кино",
      actors: ["Киану Ривз", "Силвестр Сталоне", "Пенелопа Круз"],
      country: "Россия",
      description: "Любопытный школьник Сенька каким-то чудом попадает в сказочный древний лес. Он скрыт от людских глаз мощным заклятием Бабы Яги, призванным защитить людей и весь мир от дремлющих там тёмных сил. В лесу явно творится что-то неладное. Тревожные сигналы возвещают о том, что заклятие больше не действует и пробуждение зловещего волшебства и давно поверженных врагов — это лишь вопрос времени. Чтобы наложить заклятие снова, Яга вынуждена отправиться в современный город на поиск мощнейшего оружия волшебников, дивноцвета. Там её ожидает встреча с множеством причуд современного мира, а в тёмном подземелье уже тысячу лет прячется Кощей Бессмертный, жаждущий отмщения, ведь именно Яга помогла одолеть его много веков назад. Сенька попал в сказку, но сможет ли он вырваться обратно, помочь спасти наш мир и на чьей стороне примет бой — добра или зла, всесильного Кощея или хитрой Яги?",
      duration: 90,
      premier: "3 августа 2023",
      year: 2023,
      times: ["11:00", "12:30", "14:00", "16:00", "20:30"]
    },
    {
      id: 3,
      img: "https://avatars.mds.yandex.net/get-afishanew/23114/144a6fae-059f-42cc-a998-7486aec383a2/s190x280",
      title: "Телекинез",
      genre: "Комедия",
      actors: ["Джейсон Стетхем", "Дженифер Лопез", "Пенелопа Круз"],
      country: "Германия",
      description: "Москва, 1977 год. В режиме полной секретности учёные исследуют паранормальные явления. Профессор-физик, специалист по телекинезу и гипнозу, сталкивается с необъяснимой силой, в существование которой невозможно поверить. Вскоре его дочь Анна обнаруживает у себя смертельно опасный дар.",
      duration: 120,
      premier: "7 сентября 2023",
      year: 2023,
      times: ["10:30", "12:00", "14:30", "16:30", "18:30", "20:30", "23:00"]
    },
  ]
}

const moviesSlice = createSlice({
  name: 'moviesSlice',
  initialState,
  reducers: {}
})

export const moviesReducer = moviesSlice.reducer
